import { render, staticRenderFns } from "./NavBottom.vue?vue&type=template&id=decdfe5e&scoped=true&"
import script from "./NavBottom.vue?vue&type=script&lang=js&"
export * from "./NavBottom.vue?vue&type=script&lang=js&"
import style0 from "./NavBottom.vue?vue&type=style&index=0&id=decdfe5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decdfe5e",
  null
  
)

export default component.exports